import { render } from "./CalendarLegend.vue?vue&type=template&id=f36ad0ea"
import script from "./CalendarLegend.vue?vue&type=script&lang=js"
export * from "./CalendarLegend.vue?vue&type=script&lang=js"

import exportComponent from "C:\\TeamCode\\PFSearch\\PFSearch\\pfsearch\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__